// extracted by extract-css-chunks-webpack-plugin
module.exports = {"row":"_1Xema9","tilesTitle":"_3jMQ2J","topOverlap":"_2wDCnm","carousel":"_2CcyVu","tile":"_2QigZL"};